import { defineMessages } from "react-intl";

export const messages = defineMessages( {
	paymentDetailsTitle: {
		id: "subscriptionPage.paymentDetails.title",
		defaultMessage: "Payment details",
	},
	startDate: {
		id: "subscriptionPage.paymentDetails.startDate",
		defaultMessage: "Start date",
	},
	billing: {
		id: "subscriptionPage.paymentDetails.billing",
		defaultMessage: "Billing",
	},
	nextBilling: {
		id: "subscriptionPage.paymentDetails.nextBilling",
		defaultMessage: "Next billing",
	},
	endsOn: {
		id: "subscriptionPage.paymentDetails.endsOn",
		defaultMessage: "Ends on",
	},
	paymentMethod: {
		id: "subscriptionPage.paymentDetails.paymentMethod",
		defaultMessage: "Payment method",
	},
	invoicesTitle: {
		id: "subscriptionPage.invoices.title",
		defaultMessage: "Invoices",
	},
	includedSectionTitle: {
		id: "subscriptionPage.included.title",
		defaultMessage: "Included in this subscription",
	},
	downloadLinkText: {
		id: "subscriptionPage.download.linkText",
		defaultMessage: "Download",
	},
	installLinkText: {
		id: "subscriptionPage.install.linkText",
		defaultMessage: "Install in Google Workspace",
	},
	installationGuides: {
		id: "subscriptionPage.installationGuides",
		defaultMessage: "Read our installation guides",
	},
	installationGuide: {
		id: "subscriptionPage.installationGuide",
		defaultMessage: "Read our installation guide",
	},
	yoastCoursesTitle: {
		id: "subscriptionPage.yoastCoursesTitle",
		defaultMessage: "Yoast SEO Academy courses",
	},
	yoastCoursesDescription: {
		id: "subscriptionPage.yoastCoursesDescription",
		defaultMessage: "access only for this MyYoast account",
	},
	yoastPluginsTitle: {
		id: "subscriptionPage.yoastPluginsTitle",
		defaultMessage: "Yoast SEO plugins",
	},
	yoastPluginsDescription: {
		id: "subscriptionPage.yoastPluginsDescription",
		defaultMessage: "{ used } / { limit } connected sites",
	},
	coursesTitle: {
		id: "subscriptionPage.includedPlugins.courseTitle",
		defaultMessage: "Courses",
	},
	accountServicesTitle: {
		id: "subscriptionPage.includedPlugins.accountServicesTitle",
		defaultMessage: "Apps & Services",
	},
	productsTitle: {
		id: "subscriptionPage.includedPlugins.productsTitle",
		defaultMessage: "Products",
	},
	connectedSitesTitle: {
		id: "subscriptionPage.includedPlugins.connectedSites.title",
		defaultMessage: "Connected sites ({ used } / { limit })",
	},
	provisionedNotification: {
		id: "subscriptionPage.includedPlugins.provisionedNotification",
		defaultMessage: "This subscription is provided by {displayName}. " +
			"For questions or issues related to payment or the connected sites, please contact them directly.",
		values: { displayName: "a partner" },
	},
	provisionedWithSiteManagementNotification: {
		id: "subscriptionPage.includedPlugins.provisionedWithSiteManagementNotification",
		defaultMessage: "This subscription is provided by {displayName}. " +
			"For questions or issues related to payment, please contact them directly.",
		values: { displayName: "a partner" },
	},
	connectSite: {
		id: "subscriptionPage.includedPlugins.connectSite",
		defaultMessage: "Add site",
	},
	manageSite: {
		id: "subscriptionPage.includedPlugins.manageSite",
		defaultMessage: "Manage",
	},
	linkAccountsTitle: {
		id: "subscriptionPage.connectedEmailAccess.linkedAccountsTitle",
		defaultMessage: "Linked Google accounts ({ used } / { limit })",
	},
	linkAccount: {
		id: "subscriptionPage.connectedEmailAccess.linkAccount",
		defaultMessage: "Link account",
	},
	pendingVerification: {
		id: "subscriptionPage.connectedEmailAccess.pendingVerification",
		defaultMessage: "Verification is pending…",
	},
	unlinkAccount: {
		id: "subscriptionPage.connectedEmailAccess.unlinkAccount",
		defaultMessage: "Unlink account",
	},
	removeSite: {
		id: "subscriptionPage.connectedSites.removeSite",
		defaultMessage: "Remove site",
	},
	removeSiteError: {
		id: "subscriptionPage.connectedSites.removeSiteError",
		defaultMessage: "Something unexpected happened while removing the site. Please try again later.",
	},
	docsAddonsTitle: {
		id: "subscriptionPage.docsAddonsTitle",
		defaultMessage: "Yoast SEO Google Docs add-on",
	},
	docsAddonsDescription: {
		id: "subscriptionPage.docsAddonsDescription",
		defaultMessage: "{used} / {limit} linked Google accounts",
	},
	linkGoogleAccountTitle: {
		id: "subscriptionPage.linkGoogleAccount.title",
		defaultMessage: "Link Google account",
	},
	linkGoogleAccountInstruction: {
		id: "subscriptionPage.linkGoogleAccount.instruction",
		defaultMessage: "Please enter the email address of the Google account you want to use the add-on with.",
	},
	linkGoogleAccountEmailLabel: {
		id: "subscriptionPage.linkGoogleAccount.emailLabel",
		defaultMessage: "Google account email address",
	},
	linkGoogleAccountEmailValidationError: {
		id: "subscriptionPage.linkGoogleAccount.emailValidationError",
		defaultMessage: "Please enter a valid email address.",
	},
	linkGoogleAccountEmailClarification: {
		id: "subscriptionPage.linkGoogleAccount.emailClarification",
		defaultMessage: "We’ll send a verification email to this address to confirm your Google account.",
	},
	linkGoogleAccountEmailAlreadyLinked: {
		id: "subscriptionPage.linkGoogleAccount.emailAlreadyLinked",
		defaultMessage: "This email address is already linked to this subscription.",
	},
	linkGoogleAccountNoMoreSeats: {
		id: "subscriptionPage.linkGoogleAccount.emailNoMoreSeats",

		defaultMessage: "You have reached the maximum number of linked Google accounts for this subscription. Please unlink an account before linking a new one.",
	},
	linkGoogleAccountFailedToSendInvitation: {
		id: "subscriptionPage.linkGoogleAccount.failedToSendInvitation",
		defaultMessage: "We couldn't send the verification email. Please check the email address and try again.",
	},
	linkGoogleAccountGenericError: {
		id: "subscriptionPage.linkGoogleAccount.genericError",
		defaultMessage: "An error occurred while linking the Google account. Please try again later.",
	},
	linkGoogleAccountSubmit: {
		id: "subscriptionPage.linkGoogleAccount.submit",
		defaultMessage: "Link Google account",
	},
	linkGoogleAccountCancel: {
		id: "subscriptionPage.linkGoogleAccount.cancel",
		defaultMessage: "Cancel",
	},
	linkGoogleAccountInviteSentTitle: {
		id: "subscriptionPage.linkGoogleAccount.inviteSentTitle",
		defaultMessage: "Email has been sent",
	},
	linkGoogleAccountInviteSentDescription: {
		id: "subscriptionPage.linkGoogleAccount.inviteSentDescription",
		defaultMessage: "A verification email has been sent to ",
	},
	linkGoogleAccountGotIt: {
		id: "subscriptionPage.linkGoogleAccount.gotIt",
		defaultMessage: "Got it!",
	},
	unlinkAccountConfirmation: {
		id: "subscriptionPage.connectedEmailAccess.unlinkAccountConfirmation",
		defaultMessage: "Are you sure you want to unlink this account? {email} will lose access to the Yoast SEO Google Docs add-on.",
	},
	unlinkAccountFailed: {
		id: "subscriptionPage.connectedEmailAccess.unlinkAccountFailed",
		defaultMessage: "An error occurred while unlinking the account. Please try again later.",
	},
	noConnectedSites: {
		id: "noConnectedSites.message",
		defaultMessage: "There are no connected sites to this subscription.",
	},
	title: {
		id: "subscription.title",
		defaultMessage: "",
	},
	subtitle: {
		id: "subscription.subtitle",
		defaultMessage: "",
	},
	subscriptionDetailsTitle: {
		id: "subscription.detailsTitle",
		defaultMessage: "Subscription details",
	},
	subscriptionNumber: {
		id: "subscription.number",
		defaultMessage: "Number",
	},
	subscriptionStatus: {
		id: "subscription.status",
		defaultMessage: "Status",
	},
	subscriptionActionTitle: {
		id: "subscription.actionTitle",
		defaultMessage: "Subscription actions",
	},
	orderDate: {
		id: "order.date",
		defaultMessage: "Date",
	},
	orderId: {
		id: "order.id",
		defaultMessage: "Order",
	},
	orderItems: {
		id: "order.items",
		defaultMessage: "Items",
	},
	orderTotal: {
		id: "order.total",
		defaultMessage: "Total",
	},
	orderStatus: {
		id: "order.status",
		defaultMessage: "Status",
	},
	invoiceButton: {
		id: "subscriptionDetails.buttons.invoice",
		defaultMessage: "Invoice",
	},
	cancelLink: {
		id: "subscriptionDetails.buttons.cancel",
		defaultMessage: "Cancel subscription",
	},
	cancelPending: {
		id: "subscriptionDetails.cancelPending",
		defaultMessage: "Your subscription has been cancelled.",
	},
	extendSubscriptionLabel: {
		id: "subscriptionDetails.extendSubscriptionLabel",
		defaultMessage: "Renew subscription",
	},
	switchPayentMethodLabel: {
		id: "subscriptionDetails.extendSubscriptionLabel",
		defaultMessage: "Use another payment method for your next renewal",
	},
	extendSubscription: {
		id: "subscriptionDetails.extendSubscription",
		defaultMessage: "Renew subscription",
	},
	switchPaymentMethod: {
		id: "subscriptionDetails.label.switchPaymentMethod",
		defaultMessage: "Switch payment method",
	},
	addSiteToSubscription: {
		id: "subscriptionDetails.label.addSite",
		defaultMessage: "Add site",
	},
	cannotAddSiteToSubscription: {
		id: "subscriptionDetails.cant.addSite",
		defaultMessage: "You cannot add a seat to a subscription that lasts more than five years",
	},
	addAnotherToSubscriptionLink: {
		id: "subscriptionDetails.buttons.addSeat.seat",
		defaultMessage: "Add {thing} to this subscription",
		values: { thing: "site" },
	},
	upgradeToBundleLabel: {
		id: "subscriptionDetails.label.upgradeToBundle",
		defaultMessage: "Upgrade",
	},
	upgradeToBundleLink: {
		id: "subscriptionDetails.link.upgradeToBundle",
		defaultMessage: "Upgrade subscription",
	},
	switchToAutomaticLabel: {
		id: "subscriptionDetails.switchToAutomaticLabel",
		defaultMessage: "Automatic renewal",
	},
	switchToAutomatic: {
		id: "subscriptionDetails.switchToAutomatic",
		defaultMessage: "Enable automatic payments for future renewals",
	},
	switchToBiennialButton: {
		id: "subscriptionDetails.switchToBiennialButton",
		defaultMessage: "Get 2-year renewal (15% off)",
	},
	switchToBiennialDescription: {
		id: "subscriptionDetails.switchToBiennialDescription",
		defaultMessage: "This special one-time offer is our way of saying thanks for being a loyal customer.",
	},
	undoSwitchToBiennialButton: {
		id: "subscriptionDetails.undoSwitchToBiennial",
		defaultMessage: "Undo 2-year renewal",
	},
	undoSwitchToBiennialDescription: {
		id: "subscriptionDetails.undoSwitchToBiennialDescription",
		defaultMessage: "This 2-year renewal starts on your next billing date and will automatically return to yearly after that.",
	},
} );
